import React from 'react';
import { FormControl, Select, MenuItem, Typography, CircularProgress, Box } from '@mui/material';
import { CloudQueue as EnvIcon } from '@mui/icons-material';
import { useEnvironment } from '../../contexts/EnvironmentContext';
import { useOrganization } from '../../contexts/OrganizationContext';

const EnvironmentSwitcher = () => {
  const { environments, selectedEnvironment, selectEnvironment, loading } = useEnvironment();
  const { selectedOrganization } = useOrganization();

  const handleChange = (event) => {
    selectEnvironment(event.target.value);
  };

  if (!selectedOrganization) {
    return null;
  }

  if (loading && environments.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  const activeEnvironments = environments.filter(env => !env.isArchived);

  if (activeEnvironments.length === 0) {
    return (
      <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', py: 1 }}>
        No environments
      </Typography>
    );
  }

  return (
    <FormControl fullWidth size="small">
      <Select
        value={selectedEnvironment?.id || ''}
        onChange={handleChange}
        startAdornment={<EnvIcon sx={{ mr: 1, fontSize: 20, color: '#697079' }} />}
        sx={{
          bgcolor: '#fff',
          fontSize: '13.5px',
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: 'divider'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#9AA1AA'
          },
          '.MuiSvgIcon-root': {
            color: '#697079'
          }
        }}
      >
        {activeEnvironments.map((env) => (
          <MenuItem key={env.id} value={env.id}>
            {env.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default EnvironmentSwitcher;
